import styled, { css } from 'styled-components'

import { PriceWrapper } from '@/components/Price/Price.styles'

export const DetailsModalContent = styled.div`
  display: flex;
  flex-direction: column;
  min-height: clamp(32rem, 68vh, 74rem);

  @media (max-width: 1100px) {
    min-height: auto;
  }
`

export const DetailsModalHero = styled.div`
  display: flex;
  gap: 5%;
  align-items: center;
`

export const DetailsModalMedia = styled.div`
  flex: 0 0 30%;
  overflow: hidden;
  max-width: 25%;

  img {
    display: block;
    width: 100%;
    object-fit: cover;
  }

  @media (max-width: 1100px) {
    width: 100%;
    min-width: 0;
    max-width: none;
  }
`

export const DetailsModalInfo = styled.div`
  h3 {
    font-family: ${props => props.theme.font.primary};
    font-weight: 600;
    font-size: 2rem;
    line-height: 1.1;
    margin-bottom: 0.25rem;
  }

  p {
    margin-bottom: 0;
    font-size: 1.1rem;
    color: ${props => props.theme.color.muted};
  }
`

export const DetailsModalDivider = styled.hr`
  border: 0;
  border-top: 1px solid ${props => props.theme.color.line};
  margin: 3rem 0;

  ${props =>
    props.theme.accessibilityMode &&
    css`
      margin: 1.5rem 0;
    `}
`

export const DetailsModalSection = styled.div`
  max-width: 96rem;
  width: 100%;
  margin: 0 auto;
`

export const DetailsModalDateTime = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  margin-top: 1rem;
  font-size: 1.25rem;
  font-weight: 500;
  color: ${props => props.theme.color.primaryDark};

  svg {
    width: 1.25em;
    height: 1.25em;
    fill: currentColor;
  }
`

export const DetailsModalTitle = styled.h4`
  font-size: 1.5rem;
  line-height: 1.1;
  margin-bottom: 2rem;
`

export const DetailsModalFooter = styled.div`
  display: flex;
  align-items: center;
  gap: 2rem;
`

export const DetailsModalSummary = styled.div`
  display: flex;
  align-items: center;
  font-size: 1.1rem;
  color: ${props => props.theme.color.muted};
  margin-left: auto;

  ${PriceWrapper} {
    color: ${props => props.theme.color.global};
    margin-left: 0.75rem;
    font-size: 1.75rem;
    font-weight: 600;
  }
`
